import styled, { x } from '@xstyled/styled-components';
import React, { useEffect } from 'react';
import { t } from 'ttag';
import { select } from '~/lib/select';
import { Button } from '~/ui/buttons/Button';
import { Flex } from '~/ui/flex/Flex';
import { LlamaModal } from '~/ui/llama-modal/LlamaModal';
import { Logo } from '~/ui/logo/Logo';
import { TrainingState, useTrainingStore } from '../state';
import { OnboardingStages, useOnboardingStore } from './Store';
import { useTrainingUrl } from '~/training/useTrainingUrl';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';

const IntroWrapper = styled.div`
  .modalStyleForDarkTheme {
    height: fit-content;
  }
`;

const selector = (s: TrainingState) =>
  select(s, 'firstName', 'companyName', 'logoUrl', 'title');

export const Intro = () => {
  const { companyName, logoUrl, title } = useTrainingStore(selector);
  const { stage, next } = useOnboardingStore(({ stage, next }) => ({
    stage,
    next
  }));

  const trainingNext = useTrainingStore(s => s.next);
  const url = useTrainingUrl();
  const history = useHistory();

  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const goToSequence = async () => {
    const id = await trainingNext();

    if (params.get('menu') === 'true') {
      history.push(`${url}/${id}?menu=true`);
    } else {
      history.push(`${url}/${id}`);
    }
  };

  useEffect(() => {
    if (params.get('skip_onboarding') === 'true') {
      goToSequence();
    }
  }, []);

  // const welcomeMessage = `${companyName || 'EasyLlama'} ${title}`;
  const welcomeMessage = `${title}`;

  return (
    <IntroWrapper>
      {stage === OnboardingStages.Intro && (
        <LlamaModal horizontal="center" vertical="center">
          <Flex
            w="md"
            minHeight="md"
            flexDirection="column"
            p="xl"
            alignItems="center"
            justifyContent="space-between"
          >
            <x.div className="logoDark">
              <Logo src={logoUrl} height={36} />
              {!logoUrl && <p style={{paddingBottom: '20px'}}>{companyName}</p>}
            </x.div>
            <x.h2 fontFamily="llama">{t`Welcome!`}</x.h2>
            <p>{t`Welcome to the ${welcomeMessage} training. Here are a couple of facts you need to know before you start.`}</p>
            <Button mt={'20px'} onClick={next}>{t`Continue`}</Button>
          </Flex>
        </LlamaModal>
      )}
    </IntroWrapper>
  );
};
